import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
class IssuesBar extends Component {
    render() {
        const { errors, warnings, height, width, className, ...rest } = this.props;
        let classes = `issues-bar`;
        if (className) {
            classes += ' ' + className;
        }
        const sum = errors + warnings, errorsWidth = sum > 0 ? width * (errors / sum) : 0, issuesWidth = sum > 0 ? width * (warnings / sum) : 0;
        return (_jsx("svg", { ...rest, version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: width + 'px', height: height + 'px', viewBox: `0 0 ${width} ${height}`, className: classes, children: sum === 0 ? null : (_jsxs("g", { children: [_jsx("rect", { x: 0, y: 0, width: errorsWidth, height: height, className: "issues-bar__errors" }), _jsx("rect", { x: errorsWidth, y: 0, width: issuesWidth, height: height, className: "issues-bar__warnings" })] })) }));
    }
}
IssuesBar.defaultProps = {
    height: 20,
    width: 100,
    className: '',
};
export default IssuesBar;
